import { useState, useEffect, useRef } from 'react'

export function useDraggable(width, height) {
    const [position, setPosition] = useState(() => ({
        x: 16,
        y: window.innerHeight - height - 16,
    }))
    const [isDragging, setIsDragging] = useState(false)
    const offset = useRef({ x: 0, y: 0 })
    const activePointerId = useRef(null)

    const onPointerDown = (e) => {
        if (!e.isPrimary) return
        e.preventDefault()
        e.currentTarget.setPointerCapture(e.pointerId)
        activePointerId.current = e.pointerId
        offset.current = { x: e.clientX - position.x, y: e.clientY - position.y }
        setIsDragging(true)
    }

    const onPointerMove = (e) => {
        if (activePointerId.current !== e.pointerId) return
        setPosition({
            x: Math.max(0, Math.min(e.clientX - offset.current.x, window.innerWidth - width)),
            y: Math.max(0, Math.min(e.clientY - offset.current.y, window.innerHeight - height)),
        })
    }

    const endDrag = (e) => {
        if (activePointerId.current !== e.pointerId) return
        if (e.currentTarget.hasPointerCapture?.(e.pointerId)) {
            e.currentTarget.releasePointerCapture(e.pointerId)
        }
        activePointerId.current = null
        setIsDragging(false)
    }

    useEffect(() => {
        const onResize = () => setPosition((p) => ({
            x: Math.max(0, Math.min(p.x, window.innerWidth - width)),
            y: Math.max(0, Math.min(p.y, window.innerHeight - height)),
        }))
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [width, height])

    return {
        position,
        isDragging,
        dragHandleProps: {
            onPointerDown,
            onPointerMove,
            onPointerUp: endDrag,
            onPointerCancel: endDrag,
        },
    }
}
